import { Subject } from 'rxjs';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SelectItem, LazyLoadEvent, Table } from 'primeng';
import { Router, ActivatedRoute } from '@angular/router';
import { ICustomer } from '../../interfaces/customer';
import { ICustomerFilter } from '../../interfaces/customer-filter';
import { IPageResult } from '../../interfaces/page-result';
import {
  CustomerService,
  OrganisationOrderPeferenceService,
  OrganisationTagsService,
  UserService,
} from '../../services';
import { FilterStateService } from '../../services';
import { CustomerTaggingComponent } from './customer-tagging.component';
import { debounceTime } from 'rxjs/operators';
import { SupplierCapabilityAuditDTO } from '../../interfaces/capability-audit/supplier-capability-audit.dto.interface';
import { CapabilityAuditService } from '../../services/capability-audit/capability-audit.service';
import { CapabilityAuditAreaEnum } from '../../enums/capability-audit/capability-audit-area.enum';
import { ICustomerOrderPreference } from '../../interfaces/organisation-order-preference';
import { ITaggingAudit } from '../../interfaces/tagging-audit';

@Component({
  selector: 'customer',
  templateUrl: './customer.component.html',
  encapsulation: ViewEncapsulation.None, // todo: check why
  styleUrls: ['./customer.component.css'],
})
export class CustomerComponent implements OnInit {
  public page: IPageResult<ICustomer> = {
    items: [],
    total: 0,
  };

  public selectedItem;
  public isAvailableEditing: boolean = false;
  public user: string = 'vme';
  public showViewDialog: boolean = false;
  public filter: Subject<ICustomerFilter>;
  public filterVal: ICustomerFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public currentCustomer: ICustomer;
  public filterString: string;
  public organisationtypes: SelectItem[];
  public orgTypeId: number = 0;
  public msgs: any[];
  public isLoading = false;

  public capabilityAudits: SupplierCapabilityAuditDTO[] = [];
  public taggingAudits: ITaggingAudit[] = [];
  public customerOrderPreferences: ICustomerOrderPreference[] = [];
  public showAuditDialog = false;
  public auditOrg: any;
  public CapabilityAuditArea = CapabilityAuditAreaEnum;

  @ViewChild('customerTagging') customerTagging: CustomerTaggingComponent;

  organisationStatusOptions: SelectItem[] = [
    { value: 'all', label: 'View All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Deactivated' },
    { value: 'suspended', label: 'Suspended' },
  ];

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private filterStateService: FilterStateService,
    private organisationTagsService: OrganisationTagsService,
    private capabilityAuditService: CapabilityAuditService,
    private organisationOrderPeferenceService: OrganisationOrderPeferenceService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.route.data.subscribe((data: any) => {
      this.orgTypeId = data.orgTypeId;
    });

    this.isAvailableEditing = this.canUserEdit();

    // Restore filter state
    if (this.filterStateService.orgFilterVal) {
      this.filterVal = Object.assign({}, this.filterStateService.orgFilterVal);
      this.filterStateService.orgFilterVal = null;
    } else {
      this.initDefaultFilter();
    }

    this.getOrganisationTypes();

    this.filter = new Subject<ICustomerFilter>();
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });
    this.filter.next(this.filterVal);
  }

  load(filter: ICustomerFilter) {
    console.log('FILTER: ', filter);
    this.isLoading = true;

    this.customerService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
      this.isLoading = false;

      console.log('Customers: ', result.items);
    });
  }

  showDetails(id: number) {
    this.customerService.get(id).then((result) => {
      this.displayDialog = true;
      this.currentCustomer = result;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  AddOrganisation(User: string) {
    this.router.navigate(['app/organisations/0'], { queryParams: { user: User } });
  }

  getOrganisationTypes() {
    this.customerService.getTypes().then((result) => {
      this.organisationtypes = [{ label: 'All Organisation Types', value: 0 }];
      if (result != null) {
        result.forEach((item) => {
          if (item.name != 'VME' && item.name != 'Both') {
            this.organisationtypes.push({ label: item.name, value: item.id });
          }
        });
      }
    });
  }

  goToDetails(id: number, OrgTypeId: number, User: string) {
    this.filterStateService.orgFilterVal = this.filterVal;
    this.router.navigate(['app/organisations/' + id], {
      queryParams: { orgId: OrgTypeId, user: User },
    });
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name',
      sortOrder: 1,
      filters: {
        name: {},
        addressLine1: {},
        companyRegistrationNumber: {},
        country: {},
        organisationTypeName: {},
        postcode: {},
        town: {},
        orgStatus: {},
      },
    };
  }

  canUserEdit() {
    const user = this.userService.currentUser;
    if (!user) {
      return false;
    }

    // these roles are duplicated from the CustomersController, if there is a change, these need to be updated.
    const roles = ['ACCM', 'AADM', 'OPSA', 'VDIS', 'CUSL'];

    return user.roles.filter((x) => x.isBelong && roles.indexOf(x.name) !== -1).length > 0;
  }

  showCustomerDetail(selectedItem) {
    if (selectedItem == null) {
      return;
    }

    this.showViewDialog = true;
  }

  CustomerTags(selectedItem) {
    // call show method on cusomer tagging component
    this.customerTagging.showTagging(selectedItem);
  }

  closeViewDialog() {
    this.showViewDialog = false;
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filter.next(this.filterVal);
  }

  goToUsers(id: number) {
    this.filterStateService.orgFilterVal = this.filterVal;
    this.router.navigate(['app/vmeusers/' + id], { queryParams: { backTo: 'app/organisations' } });
  }

  async showAudit(org) {
    this.auditOrg = org;

    // load audit data for current organisation
    this.capabilityAuditService.getAudits(org.id).then((res) => {
      this.capabilityAudits = res;
    });

    this.organisationTagsService.getAudit(org.id).then((res) => {
      this.taggingAudits = res;
    });

    this.organisationOrderPeferenceService
      .search({
        filters: {
          component: { value: 'organisations' },
          targetOrganisationId: { value: org.id },
          organisationId: { value: null },
        },
      })
      .then((res) => {
        this.customerOrderPreferences = res;
      });

    // show audit dialog
    this.showAuditDialog = true;
  }

  splitByCaps(text: string) {
    return text.replace(/(?!^)([A-Z]|\d+)/g, ' $1');
  }

  replaceAuditDescription(item: any) {
    const x = item.description;

    // Look for pattern "tag id X" and replace with tag name
    const regex = /tag id (\d+)/g;
    const subst = 'tag "' + item.tagEntity.name + '"';
    const result = x.replace(regex, subst);

    return result;
  }
}
